import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from "@ngrx/store";
import {coreReducers} from "@core/store/core.reducers";
import {StoreDevtoolsModule} from "@ngrx/store-devtools";
import {environment} from "@env";


@NgModule({
  declarations: [

  ],
  imports: [
    CommonModule,
    StoreModule.forRoot(coreReducers, {
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
        strictActionSerializability: false,
        strictStateSerializability: true
      }
    }),
    StoreDevtoolsModule.instrument({
      name: 'ConfCooperative',
      maxAge: 25,
      logOnly: environment.production
    }),
  ]
})
export class CoreStoreModule { }
